export interface ItemOption {
  value: number;
  name: string;
}


//Product Category Type
export const CategoryType: ItemOption[] = [
  { value: 1, name: "Product" },
  { value: 2, name: "Epuja" },
  { value: 3, name: "Kundli & Prediction" },
  { value: 4, name: "Blog" },
  { value: 5, name: "Yoga" },
];
